import { IconComponent } from "@/ui/icon";
import { useTheme } from "@providers/theme";

const Logo = () => {
  const { isDark } = useTheme();

  return (
    <IconComponent
      name={isDark ? "darkLogo" : "logo"}
      className="w-[8.625rem] h-[2.25rem]"
    />
  );
};

export default Logo;
